<template>
	<div>
		<van-nav-bar title="选择地址" left-arrow @click-left="onClickLeft"/>
		<van-address-list
		  v-model="chosenAddressId"
		  :list="list"
		  :disabled-list="disabledList"
		  disabled-text="以下地址超出配送范围"
		  default-tag-text="默认"
		  @add="onAdd"
		  @edit="onEdit"
		/>
	</div>
</template>

<script>
	export default{	
		name:"addressList",
		data(){
			return{
				chosenAddressId: '1',
				list: [
				        {
				          id: '1',
				          name: '张三',
				          tel: '13000000000',
				          address: '浙江省杭州市西湖区文三路 138 号东方通信大厦 7 楼 501 室',
				          isDefault: true,
				        }
				      ],
				      disabledList: [
				        {
				          id: '3',
				          name: '王五',
				          tel: '1320000000',
				          address: '浙江省杭州市滨江区江南大道 15 号',
				        },
				      ],
			}
		},
		methods:{
			onClickLeft(){
				this.$router.go(-1)
			},
			onAdd() {
				  this.$router.push("/addressEdit")
			},
			onEdit(item, index) {
			      this.$router.push("/addressEdit")
			},
		}
	}
</script>

<style>
</style>
